import { types } from "../types/types";
import { HotelInterface } from '../interfaces/HotelInterface';

const initialState: HotelInterface = null;

export const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.initdata:
            return { ...action.payload };

        default:
            return state;
    }
}
